import * as React from "react";
import { HudBottomRightOptions } from "../../options/HudBottomRightOptions";
export var BF2HudBottomRight = function () { return React.createElement(HudBottomRightOptions, null); };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/hud/BF2HudBottomRight.tsx
// module id = 2274
// module chunks = 3